const script = document.createElement("script");
script.src = "/widget.js";
script.defer = true;
script.dataset.endpoint = "https://feedback.otterrizz.com";
script.dataset.appVersion = __APP_VERSION__;
script.dataset.appBuild = __BUILD_TIME__;
script.dataset.gitSha = __GIT_SHA__;
document.body.append(script);
